"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Keyline = void 0;
Object.defineProperty(exports, "ScrollArea", {
  enumerable: true,
  get: function () {
    return _ScrollArea.ScrollArea;
  }
});
var _Keyline = require("./styled/Keyline");
var _ScrollArea = require("./components/ScrollArea");
/**
 * @deprecated Please use the ScrollArea component instead.
 */
const Keyline = _Keyline.Keyline;
exports.Keyline = Keyline;
//# sourceMappingURL=index.js.map